<template>
  <div class="modal-wrapper">
    <div class="modal-dialog extra-large-modal" role="document">
      <div class="modal-content modal-content--scrollable ">
        <div class="modal-header">
          <button type="button" class="close" @click="$emit('close')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Confirmação de curso
          </h4>
        </div>
        <div class="modal-body modal-body--scrollable">
          <p>
            Aluno respondeu que o curso que ele selecionou <strong>{{ sameCourseLabel }}</strong> que ele cursa
            atualmente no Quero Pago.
          </p>
          <p>Selecione abaixo qual curso do Quero Pago se iguala ao curso do Parcelamento:</p>
          <div class="row parcelamento-course-wrapper">
            <div class="col-md-6">
              <div class="row">
                <div class="col-md-12 course-confirmation-title">
                  Curso que ele escolheu no Parcelamento
                </div>
              </div>

              <course-card :course="parcelamentoCourse" course-type="parcelamento" />
            </div>
            <div class="col-md-6">
              <div class="row">
                <div class="col-md-12 course-confirmation-title">
                  Cursos que ele cursa atualmente no Quero Pago
                </div>
              </div>

              <div class="row" v-for="course in courses" :key="course.id">
                <div class="col-md-12">
                  <course-card
                    :course="course"
                    course-type="quero-pago"
                    v-model="selectedQueroPagoCourse"
                    @input="courseSelected"
                  />
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <course-card
                    :course="{ name: courseNotExistsLabel, id: 'new-course' }"
                    :course-not-exists="true"
                    v-model="selectedQueroPagoCourse"
                    course-type="quero-pago"
                    @input="courseSelected"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="row">
            <div class="col-xs-12 text-right">
              <button @click="confirmCourse" class="btn btn-primary" :disabled="!canConfirmCourse">
                Salvar Alterações
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.parcelamento-course-wrapper {
  margin-top: 16px;
}

.course-confirmation-title {
  font-weight: bold;
  text-align: center;
  padding: 8px;
}
</style>
<script>
import CourseCard from './CourseCard';

export default {
  props: {
    paymentPlan: {
      type: Object,
      default: () => {},
    },
    offer: {
      type: Object,
      default: () => {},
    },
    parcelamentoCourse: {
      type: Object,
      default: () => {},
    },
    courses: {
      type: Array,
      default: () => {},
    },
  },
  components: {
    CourseCard,
  },
  data() {
    return {
      courseNotExistsLabel: 'O curso que ele escolheu no Parcelamento não é nenhum dos cursos no Quero Pago',
      selectedQueroPagoCourse: undefined,
    };
  },
  mounted() {
  },
  computed: {
    sameCourseLabel() {
      if (this.paymentPlan.sameCourseAsQp) {
        return 'é o mesmo curso';
      }
      return 'não é o mesmo curso';
    },
    canConfirmCourse() {
      return this.selectedQueroPagoCourse !== undefined;
    },
  },
  methods: {
    courseSelected() {
      this.$emit('selectCourse', this.selectedQueroPagoCourse);
    },
    confirmCourse() {
      this.$emit('finish');
    },
  },
};
</script>
